import { comparisonData } from '@/mocks/categories';

export default function ComparisonTable() {
  const headers = ['Platform', 'Product Links', 'QC Support', 'Ease of Use', 'Updates'];

  const getRatingClass = (value: string) => {
    switch (value) {
      case 'Excellent':
        return 'bg-primary-100 text-primary-700';
      case 'Good':
        return 'bg-secondary-100 text-secondary-700';
      case 'Easy':
        return 'bg-primary-100 text-primary-700';
      case 'Daily':
        return 'bg-primary-100 text-primary-700';
      case 'Weekly':
        return 'bg-secondary-100 text-secondary-700';
      case 'Medium':
        return 'bg-accent-100 text-accent-700';
      case 'Monthly':
        return 'bg-accent-100 text-accent-700';
      default:
        return 'bg-background-200 text-foreground-600';
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-page">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            AllChinaBuy Spreadsheet vs Other Platforms
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg">
            See how our AllChinaBuy Spreadsheet compares to alternative buying platforms on product coverage, QC support, usability, and update frequency.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-background-200/70 bg-background-100">
                {headers.map((header) => (
                  <th
                    key={header}
                    className="px-5 py-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap"
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr
                  key={row.platform}
                  className={`border-b border-background-200/50 transition-colors hover:bg-background-50 ${
                    idx === 0 ? 'bg-primary-50/30' : ''
                  }`}
                >
                  <td className="px-5 py-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {row.platform}
                    {idx === 0 && (
                      <span className="ml-2 inline-block px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-[10px] font-semibold">
                        RECOMMENDED
                      </span>
                    )}
                  </td>
                  <td className="px-5 py-4">
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getRatingClass(row.productLinks)}`}>
                      {row.productLinks}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getRatingClass(row.qcSupport)}`}>
                      {row.qcSupport}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getRatingClass(row.easeOfUse)}`}>
                      {row.easeOfUse}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${getRatingClass(row.updates)}`}>
                      {row.updates}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}